module.exports = __webpack_public_path__ + "static/media/DeliveryFeeUpload.7eb970ba.zip";